import {useQuery} from "@tanstack/react-query";

import {useStoredUserProperty} from "@/src/modules/core/store/user-property";

import {vehiclesService} from "../services";

type UseAccountabilityParams = {
  vehicleId: number | null;
  householdId: number | null;
  enabled?: boolean;
};

export default function useAccountability({
  vehicleId,
  householdId,
  enabled = true,
}: UseAccountabilityParams) {
  const userProperty = useStoredUserProperty();
  const contextPropertyId = userProperty?.id ?? null;
  const isEnabled = enabled && Boolean(vehicleId) && Boolean(householdId);
  const query = useQuery({
    queryKey: ["vehicles", "accountability", vehicleId, householdId, contextPropertyId],
    queryFn: () =>
      vehiclesService.getAccountability(
        vehicleId!,
        householdId!,
        contextPropertyId ?? undefined,
      ),
    enabled: isEnabled,
    retry: false,
  });

  const accountability = query.isSuccess ? query.data : null;

  return {...query, accountability};
}
